import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "relative"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_font_style = _resolveComponent("font-style");
  const _component_slider_input = _resolveComponent("slider-input");
  const _component_uploadfile = _resolveComponent("uploadfile");
  const _component_el_button = _resolveComponent("el-button");
  const _component_gpickr = _resolveComponent("gpickr");
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createVNode(_component_el_tabs, {
    modelValue: $data.switchtab2,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.switchtab2 = $event),
    class: "switchTab1 small",
    onTabClick: $options.handleClick
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "默认",
      name: "0"
    }), _createVNode(_component_el_tab_pane, {
      label: "选中",
      name: "1"
    })]),
    _: 1
  }, 8, ["modelValue", "onTabClick"]), [[_vShow, $props.styleIndex === 0 && $props.showTab]]), _createVNode(_component_font_style, {
    title: $data.fontname,
    value: $data.defaultfont,
    onFontStyle: $options.fontChange
  }, null, 8, ["title", "value", "onFontStyle"]), (_openBlock(), _createBlock(_component_slider_input, {
    key: $data.key1,
    title: `${$props.title}宽度`,
    max: 500,
    size: $data.width,
    onInput: _cache[1] || (_cache[1] = $event => $options.inputChange($event, 'width'))
  }, null, 8, ["title", "size"])), (_openBlock(), _createBlock(_component_slider_input, {
    key: $data.key1,
    title: `${$props.title}高度`,
    max: 500,
    size: $data.height,
    onInput: _cache[2] || (_cache[2] = $event => $options.inputChange($event, 'height'))
  }, null, 8, ["title", "size"])), (_openBlock(), _createBlock(_component_slider_input, {
    key: $data.key1,
    title: `${$props.title}间距`,
    max: 100,
    size: $data.margin,
    onInput: _cache[3] || (_cache[3] = $event => $options.inputChange($event, 'margin'))
  }, null, 8, ["title", "size"])), (_openBlock(), _createBlock(_component_slider_input, {
    key: $data.key1,
    title: `${$props.title}圆角`,
    max: 100,
    size: $data.borderRadius,
    onInput: _cache[4] || (_cache[4] = $event => $options.inputChange($event, 'borderRadius'))
  }, null, 8, ["title", "size"])), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "title-label mb8"
  }, "背景图片", -1)), _createElementVNode("div", _hoisted_1, [(_openBlock(), _createBlock(_component_uploadfile, {
    name: "typebtnbg",
    key: $data.key1,
    field: $data.bgfield,
    uploadList: $data.imgList,
    onFileList: _cache[5] || (_cache[5] = $event => $options.fileListHandle($event)),
    class: "mb16"
  }, null, 8, ["field", "uploadList"])), _createVNode(_component_el_button, {
    class: "materialbtn",
    onClick: _cache[6] || (_cache[6] = $event => $options.openSourceMaterial(2))
  }, {
    default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("素材库")])),
    _: 1,
    __: [8]
  })]), (_openBlock(), _createBlock(_component_gpickr, {
    title: "背景色",
    color: $data.backgroundColor,
    onColor: _cache[7] || (_cache[7] = $event => $options.colorHandle($event, 'backgroundColor')),
    key: new Date().toString()
  }, null, 8, ["color"]))]);
}